import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Companies", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Departments", -1)
const _hoisted_3 = { class: "text-h5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-h5" }, "Löschen bestätigen", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_snackbar = _resolveComponent("error-snackbar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_error_snackbar, {
      snackbar: _ctx.errorSnackbar,
      "onUpdate:snackbar": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.errorSnackbar) = $event))
    }, null, 8, ["snackbar"]),
    _createVNode(_component_v_container, { fluid: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_v_btn, { onClick: _ctx.openNewCompanyDialog }, {
                  default: _withCtx(() => [
                    _createTextVNode("Add New Company")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_data_table, {
                  headers: _ctx.companyHeaders,
                  items: _ctx.companies,
                  "item-key": 'id',
                  class: "mt-4"
                }, {
                  [`item.actions`]: _withCtx(({ item }) => [
                    _createVNode(_component_v_icon, {
                      small: "",
                      class: "mr-2",
                      onClick: ($event: any) => (_ctx.openEditCompanyDialog(item.raw))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-pencil")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_icon, {
                      small: "",
                      onClick: ($event: any) => (_ctx.confirmDelete(item.raw, 'company'))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-delete")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["headers", "items"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_v_btn, { onClick: _ctx.openNewDepartmentDialog }, {
                  default: _withCtx(() => [
                    _createTextVNode("Add New Department")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_data_table, {
                  headers: _ctx.departmentHeaders,
                  items: _ctx.departments,
                  "item-key": 'id',
                  class: "mt-4"
                }, {
                  [`item.actions`]: _withCtx(({ item }) => [
                    _createVNode(_component_v_icon, {
                      small: "",
                      class: "mr-2",
                      onClick: ($event: any) => (_ctx.openEditDepartmentDialog(item.raw))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-pencil")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_icon, {
                      small: "",
                      onClick: ($event: any) => (_ctx.confirmDelete(item.raw, 'department'))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-delete")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["headers", "items"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.editDialog,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editDialog) = $event)),
          persistent: "",
          "max-width": "600px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.itemType === 'company' ? 'Company bearbeiten' : 'Department bearbeiten'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.selectedItem.name,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItem.name) = $event)),
                                  label: "Name",
                                  required: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.selectedItem.sort_order,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedItem.sort_order) = $event)),
                                  label: "Sortierung",
                                  type: "number",
                                  required: ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "blue darken-1",
                      text: "",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editDialog = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Abbrechen")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "blue darken-1",
                      text: "",
                      onClick: _ctx.saveItem
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Speichern")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.confirmDialog,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmDialog) = $event)),
      persistent: "",
      "max-width": "300px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" Willst du das wirklich löschen? ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "blue darken-1",
                  text: "",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmDialog = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Abbrechen")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "blue darken-1",
                  text: "",
                  onClick: _ctx.proceedWithDelete
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Löschen")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}